import { useState } from "react";
import { toast } from "sonner";
import { errMsg, useApi } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

// One real test email to an internal authorised address, through every normal gate. Never touches queued backlog.
export function ActivationTestSend({ tenants }) {
  const api = useApi();
  const [tid, setTid] = useState(tenants.find((t) => t !== "*") || "");
  const [to, setTo] = useState("");
  const [r, setR] = useState(null);
  const [busy, setBusy] = useState(false);
  const send = async () => {
    setBusy(true);
    try { const { data } = await api.post("/admin/email-activation/test-send", { tenant_id: tid.trim(), to: to.trim() }); setR(data); (data.sent ? toast.success : toast.error)(data.sent ? "Email di prova inviata" : "Email di prova non inviata"); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <section className="space-y-2 rounded-lg border border-slate-200 bg-white p-4" data-testid="activation-test-send">
      <h2 className="text-base font-semibold text-slate-900">Email di prova (una sola, a un indirizzo interno autorizzato)</h2>
      <div className="flex flex-wrap gap-2">
        <Input value={tid} onChange={(e) => setTid(e.target.value)} placeholder="ID cliente approvato" className="h-9 w-56" data-testid="activation-test-tenant" />
        <Input type="email" value={to} onChange={(e) => setTo(e.target.value)} placeholder="indirizzo interno autorizzato" className="h-9 w-72" data-testid="activation-test-to" />
        <Button size="sm" onClick={send} disabled={busy || !tid || !to} data-testid="activation-test-submit">Invia prova</Button>
      </div>
      {r && <p className="text-sm text-slate-700" data-testid="activation-test-result">Esito: <b>{r.status}</b>{r.provider_id ? ` · id Resend ${r.provider_id}` : ""}{r.provider?.last_event ? ` · stato provider: ${r.provider.last_event}` : ""}{r.error ? ` · ${r.error}` : ""}{r.detail ? ` · ${r.detail}` : ""}</p>}
    </section>);
}
